import { render, staticRenderFns } from "./qa-page.html?vue&type=template&id=4e0b11a9&"
import script from "./qa-page.ts?vue&type=script&lang=ts&"
export * from "./qa-page.ts?vue&type=script&lang=ts&"
import style0 from "./qa-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports